import type { EDataType } from '@/utils/common'
import { determineType, objectToString } from '@/utils/common'
import type { ILoggerObject } from '@/ts/interfaces/ILoggerObject'

enum ELoggerURL {
    URL = '/api/apiLogger', // refers to acse-lp in landing pages endpoint (other project)
}

export function useServerLogger() {
    const formatTimestamp = (date: Date): string => {
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        const month = monthNames[date.getMonth()]
        const day = date.getDate()
        const year = date.getFullYear()
        const hour = String(date.getHours())
        const minute = String(date.getMinutes()).padStart(2, '0')
        const second = String(date.getSeconds()).padStart(2, '0')
        const milliseconds = String(date.getMilliseconds()).padStart(3, '0')

        return `[${date.getMonth() + 1}/${day}/${year}, ${hour}:${minute}:${second}.${milliseconds}]`
    }

    const eventLogger = (prefix: string, message: any): void => {
        let loggerObject: ILoggerObject = {
            payload: {},
            eventUUID: null,
        }

        const messageType: EDataType = determineType(message)

        const parseData = (data: Array<any>): ILoggerObject | ILoggerObject[] => {
            const arr: ILoggerObject[] = []
            let parsedData: any[] = data

            if (messageType === 'object') {
                parsedData = [data]
            }

            if (parsedData) {
                parsedData.forEach((item: any): void => {
                    loggerObject = {
                        eventUUID: item.eventUuid || undefined,
                        payload: item.payload || null,
                    }

                    arr.push(loggerObject)
                })
            }

            return arr
        }

        const obj = objectToString(parseData(message))

        // if (process.env.NODE_ENV === 'production') {
        //     $fetch(ELoggerURL.URL, {
        //         method: 'post',
        //         body: { timestamp: formatTimestamp(new Date()), prefix, message: obj },
        //     })
        // }
    }

    const dataLogger = (prefix: string, message: any): void => {
        let loggerObject: ILoggerObject = {
            payload: {},
        }

        const parseData = (data: Array<any>): ILoggerObject => {
            loggerObject = {
                payload: data || null,
            }

            return loggerObject
        }

        const obj = objectToString(parseData(message))

        // if (process.env.NODE_ENV === 'production') {
        //     $fetch(ELoggerURL.URL, {
        //         method: 'post',
        //         body: { timestamp: formatTimestamp(new Date()), prefix, message: obj },
        //     })
        // }
    }

    return {
        eventLogger,
        dataLogger,
    }
}
